// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IMonthlyClaimSpendDto } from './IMonthlyClaimSpendDto';
import {
    IMonthlyClaimSpendDtoFromJSON,
    IMonthlyClaimSpendDtoFromJSONTyped,
    IMonthlyClaimSpendDtoToJSON,
    IMonthlyClaimSpendDtoToJSONTyped,
} from './IMonthlyClaimSpendDto';

/**
 * 
 * @export
 * @interface INotionalPlanBalanceMonthlyBreakdownResponseDto
 */
export interface INotionalPlanBalanceMonthlyBreakdownResponseDto {
    /**
     * 
     * @type {number}
     * @memberof INotionalPlanBalanceMonthlyBreakdownResponseDto
     */
    total_claim_spend?: number;
    /**
     * 
     * @type {Array<IMonthlyClaimSpendDto>}
     * @memberof INotionalPlanBalanceMonthlyBreakdownResponseDto
     */
    monthly_breakdown?: Array<IMonthlyClaimSpendDto>;
}

/**
 * Check if a given object implements the INotionalPlanBalanceMonthlyBreakdownResponseDto interface.
 */
export function instanceOfINotionalPlanBalanceMonthlyBreakdownResponseDto(value: object): value is INotionalPlanBalanceMonthlyBreakdownResponseDto {
    return true;
}

export function INotionalPlanBalanceMonthlyBreakdownResponseDtoFromJSON(json: any): INotionalPlanBalanceMonthlyBreakdownResponseDto {
    return INotionalPlanBalanceMonthlyBreakdownResponseDtoFromJSONTyped(json, false);
}

export function INotionalPlanBalanceMonthlyBreakdownResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): INotionalPlanBalanceMonthlyBreakdownResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_claim_spend': json['total_claim_spend'] == null ? undefined : json['total_claim_spend'],
        'monthly_breakdown': json['monthly_breakdown'] == null ? undefined : ((json['monthly_breakdown'] as Array<any>).map(IMonthlyClaimSpendDtoFromJSON)),
    };
}

export function INotionalPlanBalanceMonthlyBreakdownResponseDtoToJSON(json: any): INotionalPlanBalanceMonthlyBreakdownResponseDto {
    return INotionalPlanBalanceMonthlyBreakdownResponseDtoToJSONTyped(json, false);
}

export function INotionalPlanBalanceMonthlyBreakdownResponseDtoToJSONTyped(value?: INotionalPlanBalanceMonthlyBreakdownResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_claim_spend': value['total_claim_spend'],
        'monthly_breakdown': value['monthly_breakdown'] == null ? undefined : ((value['monthly_breakdown'] as Array<any>).map(IMonthlyClaimSpendDtoToJSON)),
    };
}

